import {apiRequest} from "@/services/api_request.js";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL; //

export const getEventDetails = async (uuid) => {
    return await apiRequest(`/${uuid}/`, {method: 'GET'});
};

export const getRegistrationDetails = async (uuid) => {
    return await apiRequest(`/registration/${uuid}`, {method: 'GET'});
};

export const registerUser = async (serviceId, userData) => {
    const formData = new FormData();
    formData.append('service_id', serviceId);
    formData.append('name', userData.name);
    formData.append('country_code', userData.countryCode);
    formData.append('mobile_number', userData.mobileNumber);
    formData.append('selfie_image', userData.selfieImage);
    return await fetch(`${API_BASE_URL}/registration/`, {
        method: 'POST',
        body: formData,
    }).then(response => response.json());
};


export const verifyPin = async (registration_id, pin) => {
    const body = {registration_id: registration_id, pin: pin};
    return await apiRequest('/auth/verify-pin/', {method: 'POST', body: body});
};

export const getMatchedPhotos = async (token, uuid, offset = 0) => {
    return await apiRequest(`/matches/${uuid}?offset=${offset}`, {method: 'GET', token: token});
};


export const trackQRScan = async (uuid) => {
    return await apiRequest(`/qr/track/${uuid}`, {method: 'GET'});
};

export default {
    registerUser,
    verifyPin,
    getMatchedPhotos,
    getRegistrationDetails,
    getEventDetails,
};